import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useStyles } from './RequiredFieldUseStyles';

const RequiredField = props => {
  const { language } = props;
  const classes = useStyles();
  return (
    <div className={classes.RequiredField}>
      <span>{language.requiredField}</span>
    </div>
  );
};

RequiredField.propTypes = {
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(RequiredField);
